<div class="detail-card" [ngClass]="variant">
  <div class="d-flex flex-column gap-1">
    <div class="title">{{ title }}</div>
    <div *ngIf="!isBlank" class="detail" i18n>Payment in {{ formattedMonthYear }}</div>
    <div *ngIf="isBlank" class="detail" i18n>No payment details entered</div>
  </div>

  <div class="d-flex flex-column gap-1">
    <div class="value" [class.blank]="isBlank">{{ amount | currency }}</div>
  </div>
</div>
